import { useState } from 'react';

interface NotificationPref {
    id: string;
    label: string;
    description: string;
    inApp: boolean;
    email: boolean;
    sms: boolean;
}

const DEFAULT_PREFS: NotificationPref[] = [
    { id: 'critical-issues', label: 'Critical issues reported', description: 'Equipment marked out of service, failed inspections', inApp: true, email: true, sms: false },
    { id: 'pm-due', label: 'PM & service due reminders', description: 'Upcoming and overdue preventive maintenance', inApp: true, email: true, sms: false },
    { id: 'inspection-submit', label: 'Inspection & form submission', description: 'When a daily inspection or service form is submitted', inApp: true, email: false, sms: false },
    { id: 'billing-updates', label: 'Account & billing updates', description: 'Subscription renewals, invoices, module changes', inApp: true, email: true, sms: false },
];

export const NotificationsSection = () => {
    const [prefs, setPrefs] = useState<NotificationPref[]>(DEFAULT_PREFS);

    const togglePref = (id: string, channel: 'inApp' | 'email' | 'sms') => {
        setPrefs((prev) =>
            prev.map((p) => (p.id === id ? { ...p, [channel]: !p[channel] } : p))
        );
    };

    return (
        <section className="settings-section">
            <div className="settings-section-header">
                <div>
                    <h2 className="settings-section-title">Notification Preferences</h2>
                    <p className="settings-section-subtitle">Choose how you want to be notified about events in your account</p>
                </div>
            </div>

            <div className="settings-section-body">
                <div className="notifications-table">
                    {prefs.map((pref) => (
                        <div key={pref.id} className="notification-row">
                            <div className="notification-row-info">
                                <span className="notification-row-label">{pref.label}</span>
                                <span className="notification-row-desc">{pref.description}</span>
                            </div>
                            <div className="notification-row-toggles">
                                <label className="notification-toggle">
                                    <input
                                        type="checkbox"
                                        checked={pref.inApp}
                                        onChange={() => togglePref(pref.id, 'inApp')}
                                    />
                                    <span className="notification-toggle-label">In-app</span>
                                </label>
                                <label className="notification-toggle">
                                    <input
                                        type="checkbox"
                                        checked={pref.email}
                                        onChange={() => togglePref(pref.id, 'email')}
                                    />
                                    <span className="notification-toggle-label">Email</span>
                                </label>
                                <label className="notification-toggle">
                                    <input
                                        type="checkbox"
                                        checked={pref.sms}
                                        onChange={() => togglePref(pref.id, 'sms')}
                                    />
                                    <span className="notification-toggle-label">SMS</span>
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
